<template>
  <div>
    <v-form>
      <v-container>
        <span class="headline">{{$t('save_pump_performance_data')}}</span>
        <v-row>
          <v-col cols="12" lg="2" md="4" sm="4">
            <v-select v-model="perf.idpump_type" :items="pumpTypes" :label="$t('pump.pump_type')"></v-select>

                <v-radio-group v-model="frequency">
                  <v-radio label="50 Hz" :value="50"></v-radio>
                  <v-radio label="60 Hz" :value="60"></v-radio>
                </v-radio-group>

          </v-col>

          <v-col cols="12" md="8">
            <v-row>
            <v-textarea
              v-model="performance_data"
              :label="$t('performance_datas')"
              hint="Excell tablosunu kopyalayıp yapıştırınız."
            ></v-textarea>
            </v-row>
            <v-row>
              <!-- <span>* Head birimi {{ frequency == 50 ? "m" : "ft" }} olmalıdır. -->
              <span>* Head birimi metre (m) olmalıdır.
                </span>
            </v-row>
          </v-col>

          <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.material" label="Material" required></v-text-field>
          </v-col>-->
        </v-row>

        <div class="my-2">
          <v-col cols="12" md="6">
            <v-btn class="ma-2" @click="parseData" color="primary">{{$t('save')}}</v-btn>

            <v-btn class="ma-2" @click="goBack" color="secondary">{{$t('cancel')}}</v-btn>

          </v-col>
           
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "PompaPerformansKaydet",
  data: () => ({
    token: "",
    performance_data: "",
    frequency: 50,
    perf: {
      idpump_type: -1,
      pumpid: -1,
      m3_h: [],
      hm: [],
      effiency: [],
      npshr: []
    },
    pumps: [],
    pumpTypes: []
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypes();
  },
  methods: {
    goBack : function() {
      window.history.go(-1)
    },
    savePerformanceData: function() {

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_pump_performance_data?frequency="+this.frequency,
        data: this.perf
      })
        .then(response => {
          console.log(response.data);
          if (response.data == "1"){
           this.performance_data = ""
           this.perf.pumpid = -1
           alert(this.$t('save_success'))
          } 
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    fetchPumpTypes: function() {
      this.pumpTypes = [];
      this.$http.get(this.$API_URL + "pump_types").then(result => {
        result.data.forEach(pumpType => {
          this.pumpTypes.push({
            text: `${pumpType.type} ${pumpType.fi_e}" ${pumpType.fi_r}mm`,
            value: pumpType.idpump_type
          });
        });
      });
    },
    fetchPumps: function() {
      this.pumps = [];
      this.$http.get(this.$API_URL + "pumps").then(result => {
        result.data.forEach(pump => {
          this.pumps.push({
            text: pump.type,
            value: pump.idpump
          });
        });
      });
    },
    parseData: function() {
      // clear datas.
      this.perf.m3_h = [];
      this.perf.hm = [];
      this.perf.effiency = [];
      this.perf.npshr = [];

      var dataLines = this.performance_data
        .replace(/\t/g, " ")
        .replace(/,/g, ".")
        .split("\n");

      console.log(dataLines);

      dataLines.forEach(line => {
        if (line.indexOf("h") > -1) {
          this.perf.m3_h = line
            .substring(line.indexOf("h") + 1)
            .trim()
            .split(" ");
        } else if (line.startsWith("Eff")) {
          this.perf.effiency = line
            .substring(line.indexOf("y") + 1)
            .trim()
            .split(" ");
        } else if (line.startsWith("NPSHR")) {
          this.perf.npshr = line
            .substring(line.indexOf("R") + 1)
            .trim()
            .split(" ");
        } else {
          if (!isNaN(parseInt(line.charAt(0))))
            this.perf.hm.push(
              line
                .substring(line.indexOf("h") + 1)
                .replace("  ", " ")
                .trim()
                .split(" ")
            );
        }
      });
      console.log(this.perf);
      this.savePerformanceData();
      // console.log(this.perf.hm);
    }
  }
};
</script>
